import { Link } from "react-router-dom";
import { prefetchConferenceHub } from "@/lib/conferencePrefetch";

import { Heart, Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="py-12 bg-gradient-to-b from-background to-muted text-foreground border-t">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* OFUESI Info */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold">OFUESI</h3>
            <p className="text-muted-foreground text-sm leading-relaxed">
              Overseas Friends of Union of Evangelical Students of India - Connecting university students across United
              States of America for prayer, fellowship, and ministry support.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="font-semibold text-lg">Quick Links</h4>
            <div className="space-y-2">
              <Link
                to="/about"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="block text-muted-foreground hover:text-primary transition-colors text-sm hover:underline"
              >
                About Us
              </Link>
              <Link
                to="/regions"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="block text-muted-foreground hover:text-primary transition-colors text-sm hover:underline"
              >
                Find Your Region
              </Link>
              <Link
                to="/prayer"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="block text-muted-foreground hover:text-primary transition-colors text-sm hover:underline"
              >
                Prayer Map
              </Link>
              <Link
                to="/conference"
                onMouseEnter={prefetchConferenceHub}
                onFocus={prefetchConferenceHub}
                onTouchStart={prefetchConferenceHub}
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="block text-muted-foreground hover:text-primary transition-colors text-sm hover:underline"
              >
                Conferences
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="font-semibold text-lg">Contact</h4>
            <div className="space-y-2 text-sm">
              <div className="flex items-start space-x-2 text-muted-foreground">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span className="hover:text-primary transition-colors">1921 Narrows Lane, Silver Spring, MD 20906</span>
              </div>
              <div className="flex items-center space-x-2 text-muted-foreground">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <a
                  href="mailto:admofuesi2025@gmail.com"
                  className="hover:text-primary transition-colors hover:underline"
                >
                  admofuesi2025@gmail.com
                </a>
              </div>
            </div>
          </div>

          {/* Prayer & Support */}
          <div className="space-y-4">
            <h4 className="font-semibold text-lg">Get Involved</h4>
            <div className="space-y-2 text-sm">
              <Link
                to="/prayer"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="block text-muted-foreground hover:text-primary transition-colors hover:underline"
              >
                Join Prayer Team
              </Link>
              <Link
                to="/give"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="block text-muted-foreground hover:text-primary transition-colors hover:underline"
              >
                Support Ministry
              </Link>
              <Link
                to="/new-students"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="block text-muted-foreground text-primary hover:text-primary transition-colors hover:underline"
              >
                New Student Guide
              </Link>
              <Link
                to="/womens-ministry"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="block text-muted-foreground hover:text-primary transition-colors hover:underline"
              >
                Women's Ministry
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-white/20 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-center md:text-left">
              <p className="text-muted-foreground text-sm">
                © 2025 OFUESI - Overseas Friends of Union of Evangelical Students of India
              </p>
              <p className="text-muted-foreground text-xs mt-1">Serving faithfully since 1999 • Silver Jubilee 2024</p>
            </div>

            <div className="flex items-center space-x-2">
              <Heart className="w-4 h-4 text-ministry-gold" />
              <p className="text-muted-foreground text-sm hover:underline">
                Powered by{" "}
                <a
                  href="https://fifthaisolutions.ai"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary hover:underline font-medium"
                >
                  fifthaisolutions.ai
                </a>
              </p>
            </div>
          </div>

          <div className="text-center mt-4 pt-4 border-t border-white/10">
            <p className="text-muted-foreground text-xs">
              "The harvest is plentiful, but the laborers are few." - Matthew 9:37-38
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
